import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthProvider from "./contexts/AuthProvider";
import { MainLayout } from "./layouts/MainLayout";
import { LoadingSpinner, ToastProvider } from "@grantyd/ui";
import { Terms } from "./features/Terms";
import AboutPage from "./pages/About";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/Contact";

const LandingPage = React.lazy(
  () => import("./pages/products/DiscoveryProductPage")
);

function App() {
  return (
    <Router>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route element={<MainLayout />}>
              <Route
                path="/"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <HomePage />
                  </Suspense>
                }
              />

              <Route
                path="/terms"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <Terms tab="terms" />
                  </Suspense>
                }
              />
              <Route
                path="/privacy"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <Terms tab="privacy" />
                  </Suspense>
                }
              />
              <Route
                path="/about"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <AboutPage />
                  </Suspense>
                }
              />
              <Route
                path="/professional-services"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <ContactPage />
                  </Suspense>
                }
              />
              {/* <Route
              path="/resources"
              element={
                <Suspense fallback={<LoadingSpinner />}>
                  <ResourcesPage />
                </Suspense>
              }
            >
              <Route
                index
                element={<Navigate to="/resources/blog" replace />}
              />
              <Route path="blog" element={<Blog />} />
              <Route path="tech-docs" element={<TechDocsRoute />} />
              <Route path="guides" element={<GuidesRoute />} />
            </Route>
            <Route
              path="/resources/blog/:id"
              element={
                <Suspense fallback={<LoadingSpinner />}>
                  <ArticlePage />
                </Suspense>
              }
            />
            <Route
              path="/resources/tech-docs/:id"
              element={
                <Suspense fallback={<LoadingSpinner />}>
                  <TechDocsPage />
                </Suspense>
              }
            />
            <Route
              path="/resources/guides/:id"
              element={
                <Suspense fallback={<LoadingSpinner />}>
                  <GuidesPage />
                </Suspense>
              }
            /> */}
              <Route
                path="*"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <LandingPage />
                  </Suspense>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
